import React, { useEffect, useRef, useState } from 'react';
import { IconButton, Paper, Switch, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import Axios from 'axios';
import ErrorPopup from '../../Error/ErrorPopup';
import { useSnackbar } from 'notistack';
import { getCatIcons } from '../../../configs/helpers/utility';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';

const useStyles = makeStyles((theme) => ({
   paper: {
      // backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      // backgroundColor: "#fff",
      width: '75%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
}));

function MapCategoryRaas(props) {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const [data, setData] = useState(props.data);
   const [resp, setResp] = useState([]);
   const [innerTableData, setInnerTableData] = useState([]);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get(
         `/GSB/dashboard/reward/category/GetCategoryMapping?rewardRef=${data.rewardRef}`,
      )
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            setIsError({
               error: true,
               errorStatus: e.response.status,
               errorMessage: e.response.data.errorAppMessageTh
                  ? e.response.data.errorAppMessageTh
                  : 'เกิดข้อผิดพลาด',
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setTableData();
   }, [resp]);
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
                  icons: getCatIcons(value.iconId),
               },
            );
         });
         setIsLoading(false);
         setInnerTableData(formatted);
      }
   };
   const refreshData = () => {
      getData();
   };
   const UpdateItemCategory = (rowData) => {
      setIsLoading(true);
      let payLoad = {
         rewardRef: data.rewardRef,
         categoryRef: rowData.reference,
      };
      if (!rowData.isMapped) {
         payLoad = {
            ...payLoad,
            primary: true,
         };
         Axios.post('/GSB/dashboard/reward/category/MapCategoryReward', payLoad)
            .then((response) => {
               enqueueSnackbar('อัพเดทรายการสำเร็จ!!', {
                  variant: 'success',
               });
               refreshData();
            })
            .catch((e) => {
               LogToBackend(e);
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
                  setIsError({
                     error: true,
                     errorStatus: e.response.status,
                     errorMessage: e.response.data.errorAppMessageTh
                        ? e.response.data.errorAppMessageTh
                        : 'เกิดข้อผิดพลาด',
                  });
               } else console.log('site error');
            })
            .finally(() => {
               setIsLoading(false);
            });
      } else {
         Axios.post(
            '/GSB/dashboard/reward/category/RemoveCategoryReward',
            payLoad,
         )
            .then((response) => {
               enqueueSnackbar('อัพเดทรายการสำเร็จ!!', {
                  variant: 'success',
               });
               refreshData();
            })
            .catch((e) => {
               LogToBackend(e);
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
                  setIsError({
                     error: true,
                     errorStatus: e.response.status,
                     errorMessage: e.response.data.errorAppMessageTh
                        ? e.response.data.errorAppMessageTh
                        : 'เกิดข้อผิดพลาด',
                  });
               } else console.log('site error');
            })
            .finally(() => {
               setIsLoading(false);
            });
      }
   };
   // if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Typography variant={'h4'}>Category Mapping</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <MaterialTable
            isLoading={isLoading}
            columns={[
               {
                  field: 'categoryId',
                  title: 'ไอดีประเภท',
                  width: 150,
                  editable: 'never',
               },
               {
                  field: 'nameTh',
                  title: 'ชื่อภาษาไทย',
               },
               {
                  field: 'nameEn',
                  title: 'ชื่อภาษาอังกฤษ',
               },
               {
                  field: 'icons',
                  title: 'ไอคอน/รูปภาพ',
                  sorting: false,
                  export: false,
                  headerStyle: {
                     textAlign: 'center',
                  },
                  cellStyle: {
                     textAlign: 'center',
                  },
               },
            ]}
            data={innerTableData}
            options={{
               // selection: true,
               showTitle: false,
               headerStyle: headerStyle,
               actionsColumnIndex: -1,
               addRowPosition: 'first',
               actionsCellStyle: {
                  color: '#ccc',
               },
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            localization={{
               body: {
                  editRow: { deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?' },
               },
               header: { actions: 'ตัวจัดการ' },
            }}
            style={tableStyle}
            icons={tableIcons}
            actions={[
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <Switch
                        ref={ref}
                        {...props}
                        checked={rowData.isMapped}
                        name={rowData.reference}
                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                     />
                  )),
                  tooltip: rowData.isMapped ? 'Is Mapped' : 'No Mapping',
                  onClick: (event, rowData) => UpdateItemCategory(rowData),
               }),
            ]}
         />
      </Paper>
   );
}

export default MapCategoryRaas;
